export default __webpack_public_path__ + "static/iconoMujerParticipa-57550ba46bd85f9b9fcaa9b5709fd5f0.png";